import { DOCUMENT } from '@angular/common';
import { ComponentRef, Inject, Injectable, Type, ViewContainerRef } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { ModalComponent } from '../components/modal/modal.component';
import { BasicObject, ModalCloseData } from '../models/services.interface';

@Injectable({
    providedIn: 'root',
})
export class ModalService {
    modalComponentRef: ComponentRef<ModalComponent>;
    public modalViewComponentRef: ViewContainerRef;

    afterClosed: Observable<ModalCloseData>;
    private readonly _afterClosed = new Subject<ModalCloseData>();
    crossClicked: Observable<ModalCloseData>;
    private readonly _crossClicked = new Subject<ModalCloseData>();

    constructor(@Inject(DOCUMENT) private document: any) {
        this.afterClosed = this._afterClosed.asObservable();
        this.crossClicked = this._crossClicked.asObservable();
    }

    public open<T>(
        component: Type<T>,
        componentParams?: BasicObject,
        params?: BasicObject,
        outputs?: BasicObject,
    ): ModalComponent {
        if (this.modalComponentRef?.instance?.component?.cannotBeOverriden) {
            return this.modalComponentRef.instance;
        }

        this.modalViewComponentRef.clear();
        const componentModalRef = this.modalViewComponentRef.createComponent(ModalComponent);
        this.modalComponentRef = componentModalRef;

        if (componentParams && componentParams.hasOwnProperty('customModalFooter')) {
            componentModalRef.instance.customModalFooter = componentParams.customModalFooter;
        }

        if (componentParams && componentParams.hasOwnProperty('title')) {
            componentModalRef.instance.title = componentParams.title;
        }

        if (params && params.hasOwnProperty('standAlone')) {
            componentModalRef.instance.standAlone = params.standAlone;
        }

        if (params && params.hasOwnProperty('closeActive')) {
            componentModalRef.instance.closeActive = params.closeActive;
        }

        if (params && params.hasOwnProperty('backdropClickActive')) {
            componentModalRef.instance.backdropClickActive = params.backdropClickActive;
        }

        if (params && params.hasOwnProperty('modalSize')) {
            componentModalRef.instance.modalSize = params.modalSize;
        }

        componentModalRef.instance.component = component;
        componentModalRef.instance.params = componentParams;
        componentModalRef.instance.outputs = outputs;
        componentModalRef.instance.modalRef = this;

        return componentModalRef.instance;
    }

    close(data?: BasicObject): void {
        this._afterClosed.next(data);
        if (data?.crossClicked) {
            this._crossClicked.next(data);
        }
        this.removeModalComponent();
        this.document.querySelector('body').classList.remove('is-clipped');
    }

    private removeModalComponent(): void {
        if (this.modalComponentRef) {
            this.modalComponentRef.destroy();
            this.modalComponentRef = null;
        }
    }
}
